import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030';

@Pipe({
  name: 'customFullDate',
  standalone: true,
})
export class CustomFullDatePipe implements PipeTransform {
  transform(date: string | null | undefined): string {
    if (!date?.trim()) {
      return 'No data';
    }

    const cleanedDate = date.replace(' UTC', '');
    const formattedDate = moment
      .tz(cleanedDate, 'America/New_York')
      .format('MMM D, YY: HH:mm');

    return formattedDate ?? 'No data';
  }
}
